// extracted by mini-css-extract-plugin
export default {"ToggleInputBlock":"ToggleInputBlockprpID","toggleInputBlock":"ToggleInputBlockprpID"};